import { render, staticRenderFns } from "./Welcome.vue?vue&type=template&id=003c643c&scoped=true"
import script from "./Welcome.ts?vue&type=script&lang=ts&external"
export * from "./Welcome.ts?vue&type=script&lang=ts&external"
import style0 from "./Welcome.scss?vue&type=style&index=0&id=003c643c&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "003c643c",
  null
  
)

export default component.exports